export const SubscriberAccess = {
    Full: 1,
    Suspended: 5,
} as const

export type SubscriberAccess = (typeof SubscriberAccess)[keyof typeof SubscriberAccess]

export const SubscriberAccessLabels: Record<SubscriberAccess, string> = {
    [SubscriberAccess.Full]: 'Full',
    [SubscriberAccess.Suspended]: 'Suspended',
}
